<!-- @format -->

@if (activationInformation(); as activationInformation) {
  <app-cart-wizard-container [wizardStepKeys]="wizardStepNameKeys" [currentStep]="currentWizardStepIndex" *transloco="let t">
    <!-- Unlike in other wizard steps, do NOT autofocus the heading, because we just returned from an external payment system,
    and thus the screen reader should tell the user where they are. -->
    <app-cart-wizard-step-heading [wizardStepKeys]="wizardStepNameKeys" [currentWizardStepIndex]="currentWizardStepIndex" />
    <transloco
      key="OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.STUDY_VOUCHER_PAYMENT.THANK_YOU_TEXT"
      [params]="{ orderNumber: activationInformation.orderNumber ?? '-' }"></transloco>
    <p class="guidance">
      <fudis-icon [icon]="'info-circle-fill'" />
      {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.STUDY_VOUCHER_PAYMENT.GUIDANCE") }}
    </p>

    <fudis-heading [level]="3">
      {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.STUDY_VOUCHER_PAYMENT.COURSE_UNITS_TITLE") }}
    </fudis-heading>

    @if (purchasedStudies$ | async; as purchasedStudies) {
      @for (purchasedStudy of purchasedStudies; track purchasedStudy) {
        <div class="purchased-study">
          <fudis-heading [level]="4">
            {{ purchasedStudy.name | localizedString }} ({{ purchasedStudy.credits | decimalNumber }} {{ t("CREDITS") }})
          </fudis-heading>
          <p class="code">{{ purchasedStudy.code }}</p>
        </div>
      }
    } @else {
      <sis-loading-screen
        [descriptionKey1]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_1'"
        [descriptionKey2]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_2'">
      </sis-loading-screen>
    }

    <sis-wizard-step-buttons
      class="wizard-step-buttons"
      [backButtonDisplay]="false"
      [forwardButtonTitle]="t('OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.STUDY_VOUCHER_PAYMENT.PROCEED_TO_SUOMI_FI_BUTTON')"
      (forward)="proceedToSuomiFi()">
    </sis-wizard-step-buttons>
  </app-cart-wizard-container>
}
